export default "__VITE_ASSET__bzJZJ9I0__"